<script>
    import "./exploreProjects.css";
    import ProjectCard from "../../components/project-card/ProjectCard.svelte";
    import {
        AUTHENTICATION_URL,
        BASE_URL,
        PROJECT_STATUSES,
    } from "../../constants/constants";
    import { projectType } from "../../store";
    import { onMount } from "svelte";
    import { id } from "ethers/lib/utils";

    export let params = {};
    let projects;
    let selected =
        $projectType === PROJECT_STATUSES.LIVE ? "OnGoing" : $projectType;
    onMount(async () => {
        $projectType
            ? $projectType
            : projectType.set(params.id === "OnGoing" ? "Live" : params.id);
        await fetchProject();
        selected = params.id === "Live" ? "OnGoing" : params.id;
    });

    let options = ["OnGoing", "Completed", "Upcoming"];

    projectType.set(params.id === "OnGoing" ? "Live" : params.id);

    projectType.subscribe(() => fetchProject());

    async function fetchProject() {
        const resp = await fetch(
            `${BASE_URL}/api/projects?populate=%2A&filters[project_status]=${$projectType}`,
            {
                method: "GET",
                headers: {
                    "Content-Type": "application/json",
                    Authorization: AUTHENTICATION_URL,
                },
            }
        )
            .then((response) => {
                return response;
            })
            .then((response) => {
                return response.json();
            })
            .catch((error) => {
                console.log(error);
            });
        projects = [];
        resp.data.map((project) =>
            projects.push({ id: project.id, ...project.attributes })
        );
    }
</script>

<div class="view-all-wrapper">
    <div class="flex items-center header-listing">
        <h2 class="header-title bold">
            {selected === "Live" ? "OnGoing" : selected} Sales
        </h2>
        <div class="ml-auto">
            <div class="flex column-direction">
                <label class="title">Project Status</label>
                <select
                    bind:value={selected}
                    on:change={async () => {
                        projectType.set(
                            `${
                                selected === "OnGoing"
                                    ? PROJECT_STATUSES.LIVE
                                    : selected
                            }`
                        );
                        selected === "OnGoing"
                            ? window.history.replaceState(
                                  {},
                                  "",
                                  `#/explore-projects/OnGoing`
                              )
                            : selected === "Completed"
                            ? window.history.replaceState(
                                  {},
                                  "",
                                  `#/explore-projects/Completed`
                              )
                            : selected === "Upcoming"
                            ? window.history.replaceState(
                                  {},
                                  "",
                                  `#/explore-projects/Upcoming`
                              )
                            : "";
                        await fetchProject();
                    }}
                >
                    {#each options as value}<option {value}>{value}</option
                        >{/each}
                </select>
            </div>
        </div>
    </div>
    <div class="preview-project-listing flex flex-wrap">
        {#if projects}
            {#each projects as project}
                <ProjectCard {project} />
            {/each}
        {/if}
    </div>
</div>
